module.exports = __webpack_public_path__ + "img/1_006.f52c193e.jpg";